/* Product tabs — opens the first row of the information accordion of the
 * product page on arrival, below the breakpoint.
 *
 * Why a file of its own rather than a {% javascript %} block in the snippet:
 * `shopify theme dev` serves the compiled bundles truncated past a threshold
 * that moves from one run to the next, and a bundle that does not parse
 * registers nothing at all. Files in `assets/` are served whole. Same rule as
 * `product-gallery.js` and `product-colors.js`.
 *
 * The rows are native `<details>` (5 October 2026, they were pills until
 * then): opening and closing them needs nothing from here, and they open
 * independently of one another. Without this file, every row is closed and
 * still works.
 *
 * Markup contract (what the script looks for in the DOM):
 *
 *   <product-tabs data-open-first="<media query>"> containing:
 *     <details> one per row, in reading order
 *
 * Class names are free: nothing here reads one.
 */

class ProductTabs extends HTMLElement {
  connectedCallback() {
    /* The first row opens on arrival where the host asks for it with a media
       query in `data-open-first` — below the breakpoint, where the original
       shows "Product details" open (Juliette, 1 October 2026). Elsewhere, all
       closed. Read once: the page does not reshuffle what the reader opened
       when the window is resized. */
    const { openFirst } = this.dataset;
    if (!openFirst || !window.matchMedia(openFirst).matches) return;

    const first = this.querySelector('details');
    if (first) first.open = true;
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
